export default __webpack_public_path__ + "static/media/Group 2017.676bc72c.svg";